// Messages for operator/InvoiceDetail (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.invoice_detail.all_invoices': 'All invoices',
  'operator.invoice_detail.no_customer': 'No customer',
  'operator.invoice_detail.details': 'Invoice details',
  'operator.invoice_detail.customer': 'Customer',
  'operator.invoice_detail.shipment': 'Shipment',
  'operator.invoice_detail.issued_on': 'Issued',
  'operator.invoice_detail.due_on': 'Due',
  'operator.invoice_detail.currency': 'Currency',
  'operator.invoice_detail.tax_rate': 'Tax rate',
  'operator.invoice_detail.charges': 'Charges',
  'operator.invoice_detail.no_lines': 'No charge lines on this invoice.',
  'operator.invoice_detail.col.description': 'Description',
  'operator.invoice_detail.col.qty': 'Qty',
  'operator.invoice_detail.col.unit': 'Unit price',
  'operator.invoice_detail.col.amount': 'Amount',
  'operator.invoice_detail.subtotal': 'Subtotal',
  'operator.invoice_detail.tax': 'Tax',
  'operator.invoice_detail.total': 'Total',
}

export const zhTW = {
  'operator.invoice_detail.all_invoices': '所有發票',
  'operator.invoice_detail.no_customer': '無客戶',
  'operator.invoice_detail.details': '發票明細',
  'operator.invoice_detail.customer': '客戶',
  'operator.invoice_detail.shipment': '貨件',
  'operator.invoice_detail.issued_on': '開立日期',
  'operator.invoice_detail.due_on': '到期日',
  'operator.invoice_detail.currency': '幣別',
  'operator.invoice_detail.tax_rate': '稅率',
  'operator.invoice_detail.charges': '費用項目',
  'operator.invoice_detail.no_lines': '此發票沒有費用項目。',
  'operator.invoice_detail.col.description': '說明',
  'operator.invoice_detail.col.qty': '數量',
  'operator.invoice_detail.col.unit': '單價',
  'operator.invoice_detail.col.amount': '金額',
  'operator.invoice_detail.subtotal': '小計',
  'operator.invoice_detail.tax': '稅額',
  'operator.invoice_detail.total': '總計',
}
